import { encodeState } from './urlState';
import { FormViewParams } from '../redux/models/state.model';
import { ViewParams, viewParamsToString } from '../models/ViewParams';
import { Breadcrumb } from '../components/BreadcrumbsComponent/models/Breadcrumb';

/**
 * Создает FormViewParams для одной вьюхи
 */
export const createFormViewParams = (
  viewParams: ViewParams,
  crumb: Breadcrumb,
  dataRequest: any = null,
): FormViewParams => ({
  viewRequest: viewParams,
  dataRequest,
  breadcrumbs: {
    [viewParamsToString(viewParams)]: [crumb],
  },
});

/**
 * Клонирует стек вьюх
 */
export const cloneViewStack = (stack: FormViewParams[]): FormViewParams[] =>
  stack.map((view) => ({
    ...view,
    breadcrumbs: { ...view.breadcrumbs },
  }));

/**
 * Открывает стек вьюх в новом окне
 */
export const openNewWindow = (viewStack: FormViewParams[]): void => {
  window.open(`${window.location.origin}/app/page?s=${encodeState(viewStack)}&nav=replace`, '_blank');
};
